import { render, staticRenderFns } from "./electronicReceipt.vue?vue&type=template&id=4a265e8a&scoped=true"
import script from "./electronicReceipt.vue?vue&type=script&lang=js"
export * from "./electronicReceipt.vue?vue&type=script&lang=js"
import style0 from "./electronicReceipt.vue?vue&type=style&index=0&id=4a265e8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a265e8a",
  null
  
)

export default component.exports